module.exports = __webpack_public_path__ + "media/images/info_sim_golf-d5d6e4c8.svg";